module.exports = __webpack_public_path__ + "img/sdg3_jp.8b8fd525.png";